import { createContext } from "react";
import {
  AddressBookDeleteContextValue,
  AddressBookHandlerContextValue,
  AddressBookIndexContextValue,
} from "./";

/* ===========================================================================
 * CONTEXT: AddressBookIndexContext
 * =========================================================================== */

/**
 * @constant AddressBookIndexContext
 * * Provides configuration and UI-related state for the AddressBook index view.
 * * Responsibilities:
 * - Exposing handler configuration (registry, billing, default values).
 * - Managing shared modal configuration for the index.
 * - Providing owner and service metadata.
 * - Handling optional lifecycle callbacks.
 *
 * @type {React.Context<AddressBookIndexContextValue | undefined>}
 */
export const AddressBookIndexContext = createContext<
  AddressBookIndexContextValue | undefined
>(undefined);

/* ===========================================================================
 * CONTEXT: AddressBookHandlerContext
 * =========================================================================== */

/**
 * @constant AddressBookHandlerContext
 * * Core business logic layer for AddressBook entity manipulation.
 * * Responsibilities:
 * - Managing loading and error states for CRUD operations.
 * - Providing methods for create/update flows.
 * - Handling autosave and registry-specific persistence logic.
 * - Distributing normalized data to form consumers.
 *
 * @type {React.Context<AddressBookHandlerContextValue | undefined>}
 */
export const AddressBookHandlerContext = createContext<
  AddressBookHandlerContextValue | undefined
>(undefined);

/* ===========================================================================
 * CONTEXT: AddressBookDeleteContext
 * =========================================================================== */

/**
 * @constant AddressBookDeleteContext
 * * Logic and state for batch deletion operations.
 * * Responsibilities:
 * - Managing the deletion loader state.
 * - Exposing the concurrent multi-delete execution method.
 * - Synchronizing results with the parent list through callbacks.
 *
 * @type {React.Context<AddressBookDeleteContextValue | undefined>}
 */
export const AddressBookDeleteContext = createContext<
  AddressBookDeleteContextValue | undefined
>(undefined);
